import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { countryService, Country } from '../../services/country.service';
import boxImage from '../../assets/app/QuickActionsSection/BOXES.png';
import '../../styles/app/CalculatorWidget.css';

const CalculatorWidget: React.FC = () => {
    const navigate = useNavigate();
    const [countries, setCountries] = useState<Country[]>([]);
    const [loadingCountries, setLoadingCountries] = useState(true);
    const [country, setCountry] = useState("VE");
    const [weight, setWeight] = useState("");

    useEffect(() => {
        const fetchCountries = async () => {
            try {
                setLoadingCountries(true);
                const { receivers } = await countryService.getCountryLists();
                setCountries(receivers);
                
                // Si Venezuela está en la lista (por su iso2Country "VE" o nombre), aseguramos que esté preseleccionado
                const hasVenezuela = receivers.some(c => c.iso2Country === "VE");
                if (hasVenezuela) {
                    setCountry("VE");
                } else if (receivers.length > 0) {
                    setCountry(receivers[0].iso2Country);
                }
            } catch (err) {
                console.error("Error fetching countries in CalculatorWidget:", err);
            } finally {
                setLoadingCountries(false);
            }
        };
        fetchCountries();
    }, []);

    const handleCalculate = (e: React.FormEvent) => {
        e.preventDefault();
        // Redirigir a la calculadora pasándole los parámetros en la URL
        navigate(`/calculator?country=${encodeURIComponent(country)}&weight=${encodeURIComponent(weight)}`);
    };

    return (
        <div className="calculator-widget">
            <div className="calculator-main-layout">
                {/* Left: Form */}
                <form onSubmit={handleCalculate} className="calculator-form">
                    <h3 className="calculator-title">Calculadora de envío</h3>
                    <p className="calculator-subtitle">Cotiza tu envío en segundos</p>

                    <div className="form-group-custom">
                        <label className="label-custom">País de destino</label>
                        <select
                            value={country}
                            onChange={(e) => setCountry(e.target.value)}
                            className="select-custom"
                            disabled={loadingCountries}
                        >
                            {loadingCountries ? (
                                <option value="">Cargando países...</option>
                            ) : (
                                <>
                                    <option value="">Seleccionar País</option>
                                    {countries.map((c) => (
                                        <option key={c.id} value={c.iso2Country}>
                                            {c.name}
                                        </option>
                                    ))}
                                </>
                            )}
                        </select>
                    </div>

                    <div className="form-group-custom">
                        <label className="label-custom">Peso (lb)</label>
                        <input
                            type="text"
                            placeholder="Ej: 10"
                            value={weight}
                            onChange={(e) => setWeight(e.target.value)}
                            className="input-custom"
                        />
                    </div>

                    <button type="submit" className="calculator-btn">
                        Calcular precio <FontAwesomeIcon icon={faArrowRight} />
                    </button>
                </form>

                {/* Right: Graphic visual */}
                <div className="calculator-visual">
                    <div className="dots-pattern"></div>
                    <img src={boxImage} alt="Cajas de envío" className="visual-box-img" />
                </div>
            </div>
        </div>
    );
};

export default CalculatorWidget;

